// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Modal = require('client-v2/common/components/modal')
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const ContentAddModalArticlePreview = require('./components/article-preview')
const ContentAddModalUrlForm = require('./components/url-form')
const ContentAddModalUrlSubmitted = require('./components/url-submitted')

const bem = BemEntity('ContentAddModal')

function ContentAddModal({ className, ...props }) {
  return (
    tag(Modal, {
      className: classNames(
        className,
        bem.block()
      ),
      onDismiss: props.onDismiss
    },
      tag('div', {
        className: bem.element('content')
      },
        tag('div', {
          className: bem.element('inner')
        },
          tag('div', {
            className: bem.element('article')
          },
            tag(ContentAddModalArticlePreview, props)
          ),
          (
            props.isCollectionsModalVisible
            ? tag(ContentAddModalUrlSubmitted, {
              className: bem.element('url-submitted')
            })
            : tag(ContentAddModalUrlForm, {
              className: bem.element('url-form'),
              ...props
            })
          )
        ),
        tag(ContentAddModalFooter, props)
      )
    )
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  ContentAddModal.propTypes = {
    // Flags
    isArticleLoading: PropTypes.bool,
    isCollectionsModalVisible: PropTypes.bool,
    // Values
    className: PropTypes.string,
    article: PropTypes.shape(ArticleModelRecord.propTypes),
    postHref: PropTypes.string,
    promo: PropTypes.shape({
      href: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    }),
    url: PropTypes.string,
    // Callbacks
    onDismiss: PropTypes.func
  }
}

module.exports = ContentAddModal


function ContentAddModalPromo({
  href,
  type,
  onClick
}) {
  const verb = type === 'app'
  ? 'Download'
  : 'Install'
  const noun = type === 'app'
  ? 'Mix app'
  : 'Mix browser extension'
  return (
    tag('a', {
      className: bem.element('promo'),
      href,
      onClick
    },
      verb, ' the ', noun, '.'
    )
  )
}

function ContentAddModalFooter({
  isCollectionsModalVisible,
  postHref,
  promo,
  onDismiss
}){
  return (
    tag('div', {
      className: bem.element('footer')
    },
      promo && tag(ContentAddModalPromo, promo),
      isCollectionsModalVisible && (
        tag('div', {
          className: bem.element('buttons-wrapper')
        },
          tag(CapsuleButton, {
            className: bem.element('view-post-button'),
            href: postHref
          },
            'View post'
          ),
          tag(CapsuleButton, {
            className: bem.element('done-button'),
            onClick: onDismiss
          },
            'Done'
          )
        )
      )
    )
  )
}
